var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.toasts),function(toast){return _c('ToastMessage',{key:toast.message,staticClass:"mt-100",attrs:{"toast":toast},on:{"dismiss":_vm.dismiss}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }